export type AppRole =
  | 'LEADER'
  | 'NOMINATOR'
  | 'RECOGNITION_NOMINATOR'
  | 'ADMIN'
  | 'SUPER_ADMIN';

export type Capability =
  | 'ADMIN_CONSOLE'
  | 'LEADER_EVAL'
  | 'NOMINATE'
  | 'RECOGNIZE';

export const ACCESS_ROLES: Record<Capability, readonly AppRole[]> = {
  ADMIN_CONSOLE: ['ADMIN', 'SUPER_ADMIN'],
  LEADER_EVAL: ['LEADER', 'ADMIN', 'SUPER_ADMIN'],
  NOMINATE: ['NOMINATOR', 'ADMIN', 'SUPER_ADMIN'],
  RECOGNIZE: ['RECOGNITION_NOMINATOR', 'ADMIN', 'SUPER_ADMIN'],
};

export const MENU_ROLES: Partial<Record<Capability, readonly AppRole[]>> = {
  LEADER_EVAL: ['LEADER'],
  NOMINATE: ['NOMINATOR'],
  RECOGNIZE: ['RECOGNITION_NOMINATOR'],
};

function hasAnyRole(roles: readonly string[], allowed: readonly AppRole[]): boolean {
  return roles.some((role) => allowed.includes(role as AppRole));
}

export function canAccess(roles: readonly string[], capability: Capability): boolean {
  return hasAnyRole(roles, ACCESS_ROLES[capability]);
}

export function canSeeMenu(roles: readonly string[], capability: Capability): boolean {
  return hasAnyRole(roles, MENU_ROLES[capability] ?? ACCESS_ROLES[capability]);
}
